export const getClientToken = () => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${'user-token'.replace(/([\\.$?*|{}\\(\\)\\[\]\\\\/\\+^])/g, '\\$1')}=([^;]*)`,
    ),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
